// src/store/store.ts
import storage from "redux-persist/lib/storage";
import { persistStore, persistReducer } from "redux-persist";
import { configureStore, combineReducers } from "@reduxjs/toolkit";

import Global from "./global.store";
import CustomerAndGroups from "./sidebar.store";
import DevicesDataReducer from "./devicesData.store";
import CustomersList from "./customerList.store";
import authReducer from "./authslice";
import tableReducer from "./table.store";
import toasterReducer from "./toasterslice";
import tableModalReducer from "./tableModal.store";
import permissionReducer from "./permissionslice";
import ethernetReducer from "./ethernetslice";
import modbusclientConfigReducer from "./modbusclientConfig.store";
import diagnosticCenterReducer from "./diagnosticCenter.store";
import DevicesReducer from "./devicesStatus.store";

const persistConfig = {
  key: "root",
  storage,
  whitelist: ["auth"], // ⬅️ Persist only login state (optional)
};

const rootReducer = combineReducers({
  Global: Global.reducer,
  CustomerAndGroups: CustomerAndGroups.reducer,
  DevicesData: DevicesDataReducer.reducer,
  CustomersList: CustomersList.reducer,
  auth: authReducer, // ⬅️ Add auth slice here
  table: tableReducer, // this reducer manages main pages table state
  tableModal: tableModalReducer, // this reducer manages table modal state
  toastMessage: toasterReducer,
  permissions: permissionReducer, // this reducer manages permissions state
  ethernet: ethernetReducer, // this reducer manages ethernet modal state
  modbusClientConfig: modbusclientConfigReducer,
  diagnosticCenterState: diagnosticCenterReducer,
  devicesStatus: DevicesReducer,
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

const Store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export type RootState = ReturnType<typeof Store.getState>;
export type AppDispatch = typeof Store.dispatch;
export const persistor = persistStore(Store);
export default Store;
